export default "__VITE_ASSET__SdiABW_y__"